import { makeAutoObservable } from 'mobx';


export default class CommonStore {
  isRemote: boolean = true;
  departmentId: number | undefined = undefined;
  holderTypeId: number | undefined = undefined;
  userId: number | undefined = undefined;
  hospitalId: number | undefined = undefined;
  landingZoneUrl: string | undefined = undefined;
  redisKey: string | undefined = undefined;
  redisCache: {} | undefined = undefined;
//   isUserInRole: (roleName: string) => boolean = () => false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsRemote = (isRemote: boolean) => {
    this.isRemote = isRemote;
  };

  setDepartmentId = (departmentId: number) => {
    this.departmentId = departmentId;
  };

  setHolderTypeId = (holderTypeId: number) => {
    this.holderTypeId = holderTypeId;
  };

  setUserId = (userId: number) => {
    this.userId = userId;
  };

  setHospitalId = (hospitalId: number) => {
    this.hospitalId = hospitalId;
  };

  setLandingZoneUrl = (landingZoneUrl: string) => {
    this.landingZoneUrl = landingZoneUrl;
  };

  setRedisKey = (key: string) => {
    this.redisKey = key;
  };
  
  setRedisCache = (cacheObj: {}) => {
    this.redisCache = cacheObj;
  };

//   setIsUserInRole = (func: (roleName: string) => boolean) => {
//     this.isUserInRole = func
//   }

  getNavigationUrl = (pageUrl: string): string => {
    pageUrl = process.env.REACT_APP_REACT_ROUTER_LINK_PREPEND + pageUrl;
    if (!this.redisKey) return pageUrl;
    return `${pageUrl}?key=${this.redisKey}`;
  };
};
